// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface DelineateBasinsInput
 */
export interface DelineateBasinsInput {
  /**
   *
   */
  dem: RanaFile;
}

/**
 * Check if a given object implements the DelineateBasinsInput interface.
 */
export function instanceOfDelineateBasinsInput(value: object): value is DelineateBasinsInput {
  if (!("dem" in value) || value["dem"] === undefined) return false;
  return true;
}

export function DelineateBasinsInputFromJSON(json: any): DelineateBasinsInput {
  return DelineateBasinsInputFromJSONTyped(json, false);
}

export function DelineateBasinsInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DelineateBasinsInput {
  if (json == null) {
    return json;
  }
  return {
    dem: RanaFileFromJSON(json["dem"]),
  };
}

export function DelineateBasinsInputToJSON(json: any): DelineateBasinsInput {
  return DelineateBasinsInputToJSONTyped(json, false);
}

export function DelineateBasinsInputToJSONTyped(
  value?: DelineateBasinsInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    dem: RanaFileToJSON(value["dem"]),
  };
}
